// hostname → partnerId. Single source of truth: domainMap.json (also read by
// server.js for partner-aware static asset routing). Unknown hostnames fall
// back to DEFAULT_PARTNER_ID in resolvePartner().
//
// Adding a new partner: append the host entry to domainMap.json AND create
// the matching src/partners/{partnerId}/ folder (see onboarding checklist in
// src/config/index.ts). The resolver validates at module load that every
// value here points to a real partner.
//
// Local dev / staging hostnames are intentionally not listed — they fall back
// to SABO. To test a different partner config locally, use the ?partner=acme
// query-string override.

import map from './domainMap.json';

export const domainMap: Record<string, string> = map;
